// Diretório de clientes: pessoas que fizeram check-in ou têm dados de faturação.
export const clientesDir = {
  title: "Clientes",
  subtitle: "Todas as pessoas que fizeram check-in ou têm dados de faturação. São guardadas automaticamente e nunca duplicadas.",
  searchLabel: "Pesquisar cliente",
  searchPlaceholder: "Nome, documento, e-mail ou telefone",
  filters: {
    todos: "Todos",
    checkin: "Com check-in",
    fiscal: "Com dados fiscais",
    reservas: "Com reservas",
  },
  cols: {
    client: "Cliente",
    document: "Documento",
    phone: "Telefone",
    stays: "Estadias",
    lastStay: "Última estadia",
  },
  checkins: "{n} check-in | {n} check-ins",
  bookings: "{n} reserva | {n} reservas",
  fiscalBadge: "Fiscal",
  noDocument: "Sem documento",
  noName: "Sem nome",
  emptyTitle: "Ainda não há clientes",
  emptyText: "Todas as pessoas que concluírem um check-in aparecerão aqui automaticamente.",
  emptySearch: "Nenhum cliente corresponde a “{q}”.",
  loadError: "Não foi possível carregar os clientes.",
  pageOf: "{from}–{to} de {total}",
  prev: "Anterior",
  next: "Seguinte",
  docTypes: {
    P: "Passaporte",
    ID: "Documento nacional de identidade",
    IM: "NIE",
    I: "Cartão de identidade",
    D: "Documento nacional de identidade",
    N: "NIE",
    X: "Autorização de residência",
    CC: "Cartão de cidadão",
    CE: "Cartão de estrangeiro",
    TI: "Cartão de identidade",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "Fechar",
    createBooking: "Criar reserva",
    personal: "Dados pessoais",
    document: "Documento",
    address: "Morada",
    fiscal: "Dados fiscais",
    noFiscal: "Sem dados fiscais. São adicionados ao faturar ou em Faturação → Clientes fiscais.",
    defaultProfile: "Predefinido",
    bookings: "Reservas",
    noBookings: "Sem reservas associadas.",
    companions: "Viajou com",
    noCompanions: "Não partilhou uma reserva com mais ninguém.",
    timesTogether: "{n} vez | {n} vezes",
    invoices: "Faturas",
    noInvoices: "Sem faturas.",
    viewPdf: "Ver PDF",
    email: "E-mail",
    phone: "Telefone",
    birthDate: "Data de nascimento",
    sex: "Sexo",
    nationality: "Nacionalidade",
    docType: "Tipo",
    docNumber: "Número",
    expiry: "Validade",
    support: "Número de suporte",
    street: "Morada",
    zip: "Código postal",
    city: "Cidade",
    country: "País de residência",
    roleCheckin: "Check-in",
    roleHolder: "Titular",
    loadError: "Não foi possível abrir a ficha do cliente.",
  },
  sexes: {
    M: "Masculino",
    F: "Feminino",
  },
  picker: {
    missingPolice: "Este cliente não tem dados de polícia guardados nesta conta. Preencha-os agora e ficarão para a próxima vez.",
    searchSaved: "Pesquisar cliente guardado",
    searchPlaceholder: "Nome, documento ou telefone…",
    noResults: "Nenhum cliente guardado corresponde.",
    selected: "Dados preenchidos a partir de Clientes",
    clear: "Remover",
  },
  match: {
    title: "Este cliente já existe",
    text: "{name} já está guardado em Clientes. Pode preencher todos os seus dados com um só toque.",
    use: "Usar os seus dados",
    dismiss: "Não é esta pessoa",
    applied: "Dados de {name} preenchidos. Verifique as datas da estadia e assine.",
    companionsTitle: "Já viajou com",
    companionsHint: "Toque numa pessoa para a registar com os seus dados.",
    registerCompanion: "Registar {name}",
  },
};
